<template>
  <div class="chapter chapter--facingthemirror">
    <section class="section__facingthemirror section__facingthemirror--01">
      <div class="bg-highlight pt-8 pb-3 pb-lg-0 pt-lg-0">
        <div class="container py-lg-5">
          <div class="row">
            <div class="col-12 col-lg-10">
              <h1 class="color-white font-size-56 font-bold text-uppercase mb-2" data-aos="fade-up" data-aos-delay="600"
                  v-html="$t('PAGE02_TEXT01')"></h1>
            </div>
          </div>
        </div>
      </div>
      <div class="container my-10 my-lg-15 my-lg-20">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2">
            <div class="video--container embed-responsive embed-responsive-16by9">
              <!--              <div class="play&#45;&#45;btn" :class="{'is-playing' : isPlaying}"  data-aos="fade-up" data-aos-delay="300">
                              <img src="@/assets/icons/play_button.svg" class="icon__content play my-1" v-on:click="play()">
                              <img src="@/assets/icons/pause_button.svg" class="icon__content pause my-1" v-on:click="pause()">
                            </div>-->
              <video src="@/assets/videos/s02_facing.mp4" class="embed-responsive-item" poster="@/assets/images/02/poster-facing-the-mirror.jpg" ref="video" @ended="videoEnded()" loop muted autoplay playsinline>

              </video>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section__facingthemirror section__facingthemirror--02" :class="[additionalContent ? 'mb-5': 'pb-5']">
      <div class="container mb-4 pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-lg-10 offset-lg-1 col-12 text-center">
            <div class="box">
              <p class="font-size-32 mb-10" data-aos="fade-up" data-aos-delay="700" v-html="$t('PAGE02_TEXT01_01')"></p>
              <p class="font-bold font-size-32 color-highlight" data-aos="fade-up" data-aos-delay="800" v-html="$t('PAGE02_TEXT02')"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 mini-quiz">
            <div class="answer__item justify-content-lg-end justify-content-center" data-aos="zoom-in" data-aos-delay="50">
              <div class="answer" v-html="$t('PAGE02_TEXT03')"></div>
            </div>
            <div class="answer__item justify-content-center" data-aos="zoom-in" data-aos-delay="100">
              <div class="answer" v-html="$t('PAGE02_TEXT04')"></div>
            </div>
            <div class="answer__item justify-content-lg-start justify-content-center" data-aos="zoom-in" data-aos-delay="150">
              <div class="answer" v-html="$t('PAGE02_TEXT05')"></div>
            </div>
            <div class="answer__item justify-content-lg-end justify-content-center" data-aos="zoom-in" data-aos-delay="200">
              <div class="answer" v-html="$t('PAGE02_TEXT06')"></div>
            </div>
            <div class="answer__item  justify-content-center" data-aos="zoom-in" data-aos-delay="250">
              <div class="answer" v-html="$t('PAGE02_TEXT07')"></div>
            </div>
            <div class="answer__item justify-content-lg-start justify-content-center" data-aos="zoom-in" data-aos-delay="300">
              <div class="answer" v-html="$t('PAGE02_TEXT08')"></div>
            </div>
          </div>
          <div class="col-12 text-center d-flex justify-content-center mt-5">
            <div class="answer__item--button" data-aos="zoom-in" data-aos-delay="500" data-aos-offset="-200">
              <div class="answer--check" v-on:click="showAdditionalContent()" v-html="$t('PAGE02_TEXT09')">see result</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section__facingthemirror section__facingthemirror--03 py-5 py-lg-10 py-lg-20 mt-10" id="section__facingthemirror--03" :class="{'d-none': additionalContent == false}" ref="scrollTo">
      <div class="container pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12  col-xl-6 offset-xl-3 text-center">
            <p class="font-bold font-size-56 color-highlight text-uppercase" data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT10')"></p>
            <p class="font-bold font-size-40 color-highlight mb-8" data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT11')"></p>
            <p class="font-bold font-size-56 color-highlight text-uppercase mb-4" data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT12')"></p>
            <ul class="text-left mb-8">
              <li data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT13')"></li>
              <li data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT14')"></li>
              <li data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT15')"></li>
              <li data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT16')"></li>
            </ul>

            <p class="font-bold font-size-40 color-highlight mb-4" data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT17')"></p>
            <p class="font-bold" data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT18')"></p>
            <ul class="text-left">
              <li data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT19')"></li>
              <div data-aos="fade-up" data-aos-delay="10" class="d-flex justify-content-center plus__icon--wrapper">
                <div class="plus__icon"></div>
              </div>
              <li data-aos="fade-up" data-aos-delay="10" v-html="$t('PAGE02_TEXT20')"></li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="section__facingthemirror section__facingthemirror--04  align-items-center" :class="[additionalContent ? 'd-flex': 'd-none']">
      <div class="container-fluid pl-lg-10 pl-xl-0">
        <div class="row">
          <div class="col-12 col-lg-3 offset-lg-7 text-center">
            <p class="font-bold font-size-32 color-highlight mb-8" data-aos="fade-up" data-aos-delay="200" v-html="$t('PAGE02_TEXT21')"></p>
            <p class="" data-aos="fade-up" data-aos-delay="300" v-html="$t('PAGE02_TEXT22')"></p>

          </div>
        </div>
        <div class="row d-block d-md-none mt-5">
          <img src="@/assets/images/02/s04_p01.jpg" class="img-fluid">
        </div>
      </div>
    </section>


    <Footer :lang-key="'GLOBAL_FOOTER02'" :kapitel="'03'" :class="{'d-none': additionalContent == false}"/>

  </div>
</template>

<script>
import lrsService from "@/services/lrsService";
import Footer from "@/components/partials/Footer";
import jQuery from 'jquery';
export default {
  name: "page-020",
  components: {
    Footer
  },
  props: {
    kapitel: ""
  },
  data: function () {
    return {
      additionalContent: false,
      ageCardsActive: 1,
      tracked: false,
      moduleStatus: '',
      isPlaying: false,
      trackingPercentage: 0
    }
  },
  created() {
    this.$store.watch(
        (state, getters) => getters.moduleStatus,
        (newValue, oldValue) => {
          console.log(`Updating lang from ${oldValue} to ${newValue}`);
          this.moduleStatus = newValue;
          for (let i = 0; i < this.moduleStatus.length; i++) {
            if(this.moduleStatus[i][0]  == '02'){
              this.tracked = true;
            }
          }
        },
    );
  },
  mounted() {
    let _this = this;
    let trackingStatus = this.$store.getters.moduleStatus;

    for (let i = 0; i < trackingStatus.length; i++) {
      console.log(trackingStatus[i], trackingStatus[i][0]);
      if(trackingStatus[i][0]  == '02'){
        this.tracked = true;
        _this.incrementTrackingPercent(100);
      }
    }

    let answers = document.querySelectorAll('.answer');
    document.querySelectorAll('.answer').forEach(item => {
      item.addEventListener('click', event => {
        _this.selectAnswer(item)
      })
    })

    const section1 = this.$scrollmagic.scene({
      triggerElement: '.section__facingthemirror--04',
      triggerHook: 0,
      reverse:false
    }).on('start', function () {
      if(_this.tracked == false){
        _this.tracked = true;
        _this.incrementTrackingPercent(100);
      }

    });
    this.$scrollmagic.addScene(section1);

  },
  methods: {
    play(){
      this.$refs.video.play();
      this.isPlaying = true;
    },
    pause(){
      this.$refs.video.pause();
      this.isPlaying = false;
    },
    videoEnded(){
      this.isPlaying = false;
      this.$refs.video.currentTime = 0;
    },
    changeChapter(id){
      this.chapterActive = id;
    },
    changeAgeCard(id){
      let oldCard = this.ageCardsActive;
      this.ageCardsActive = id;
      let content = jQuery('.section__facingthemirror--03');
      let sectionOffset = jQuery(content).offset().top;
      let firstRowHeight = jQuery('.section__facingthemirror--03 > .container').children().eq(0).height();

      if(oldCard == 3){
        jQuery('html, body').animate({
          scrollTop: sectionOffset + firstRowHeight + 100
        }, 400);
      } else {
        jQuery('html, body').animate({
          scrollTop: sectionOffset + firstRowHeight + 80
        }, 400);
      }
    },
    selectAnswer(item){
      item.classList.toggle('selected');
    },
    incrementTrackingPercent(amount){
      let percentage = this.trackingPercentage + amount;
      this.trackingPercentage = percentage;
      if(this.trackingPercentage >= 100){
        lrsService.sendLRS("experienced", '02');
        lrsService.sendLRS("progressed");
      }
    },
    showAdditionalContent(){
      this.additionalContent = true;
      this.incrementScrollIndicator(10)
      setTimeout(() => {
        this.refreshAOS();
        let offset = jQuery("#section__facingthemirror--03").offset().top;
        jQuery('html, body').animate({
          scrollTop: offset -50
        }, 400);
      }, 300);
    },

  }
}
</script>

<style scoped>

</style>